/**
 * Announcements Controller
 * 
 * This controller handles the announcements dialog that is shown when the user needs to confirm an action.
*/

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dialog', 'content']
  static values = { announcementUrl: String }
  
  connect() {

    // Show modal on click on announcements button
    window.addEventListener('breadcrumbs:show-announcements', this.showAnnouncementsModal.bind(this))

    // Auto-popup disabled (VI-1674) - the announcement is no longer relevant; the breadcrumbs button still opens it on demand.
    // const wasShown = localStorage.getItem('announcements-singlecalc-shown') // TODO: This key is temporary (See https://vesselindex-team.atlassian.net/browse/VI-1437)
    // if (!wasShown) {
    //   this.showAnnouncementsModal()
    //   localStorage.setItem('announcements-singlecalc-shown', 'true')
    // }
  }

  async showAnnouncementsModal() {
    await this.loadContent()
    this.dialogTarget.showModal()
  }

  async loadContent() {
    if (!this.hasContentTarget || this.contentLoaded) return

    const response = await fetch(this.announcementUrlValue, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })

    if (!response.ok) return

    this.contentTarget.innerHTML = await response.text()
    this.contentLoaded = true
  }

  close() {
    this.dialogTarget?.close()
    localStorage.setItem('announcements-singlecalc-dismissed', 'true')
    this.dispatch('dismissed')
  }
}